import dayjs from 'dayjs'
import { getParam } from '@vt/utils'
import { getApiVersion, http } from '../utils/domain'
import { buildQueries } from '../utils/transformers'

const makeHeaders = () => {
  return {
    'X-Header-Timestamp': dayjs().valueOf(),
    'X-Header-PlatformId': '957',
    // 'X-Header-Signature': '9c55079006bf488990a9f2032bdd5ae6',
  }
}

// 文件上传
// 为适配小程序上传添加一个 headers参数
export const upload = (formData, headers) => {
  return http()
    .post(`${getApiVersion()}/apps/givrali`, null, {
      throwHttpErrors: false,
      headers: headers ? { ...makeHeaders(), ...headers } : makeHeaders(),
      body: formData,
    })
    .json()
}
export const addWatermarkToImage = (
  url,
  text,
  size,
  color = 'white',
  alpha = 0,
  default_size = true
) => {
  return `https://watermark.survey.work/image_server/unsafe/fit-in/filters:label_sp(${text},${size},${color},${alpha},${default_size})/${url}`
}

// 导出点位指标统计表
export const exportStatisticExcel = (appId, tbId, standard, filters, type) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/pointStandardCommonFunctions/tbs/${tbId}/areaStandardStatisticExcelExport?whetherExportAllStandard=${standard}`,
      type === 'all' ? buildQueries({ filters }) : filters
    )
    .json()
}
// 远洋导出列表（定制）
export const exportYYDownloadBigTable = (appId, tbId, filters, show) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tb_download/downloadBigTable?tbId=${tbId}&show=${show}`,
      buildQueries({ filters })
    )
    .json()
}
// 导出问题大表
export const exportDownloadBigTable = (
  appId,
  standardIds,
  dataTid,
  standardTid,
  filters,
  show,
  params
) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tb_download/fetchBigTable?standardIds=${standardIds}&dataTid=${dataTid}&standardTid=${standardTid}&show=${show}`,
      { ...buildQueries({ filters }), ...params }
    )
    .json()
}

// 获取导出修改记录id
export const exportDownloadLogInfo = (appId, filters, query) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tb_download/downloadBigTableLogInfo${getParam(
        query
      )}`,
      buildQueries({ filters })
    )
    .json()
}

// 获取文件下载id
export const easyDownloadData = ({
  appId,
  tbId,
  viewId,
  filters,
  sorts,
  type,
  props = {},
}) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/tb_download/easyDownloadData?tbId=${tbId}&viewId=${viewId}`,
      type === 'all'
        ? { ...buildQueries({ filters, sorts }), ...props }
        : { ...filters, ...props }
    )
    .json()
}

// 导出文件地址
export const easyDownloadUrl = (appId, res, token) => {
  return `${getApiVersion()}/apps/${appId}/tb_download/getFile?id=${res}&token=${token}`
}

export const createGenerateTask = (fetchUrl, data) => {
  return http().post(`${getApiVersion()}/${fetchUrl}`, data).json()
}

// 文件名授权接口
export const swapOssUrl = (data) => {
  return http()
    .post(`${getApiVersion()}/apps/givrali/swapOssUrl`, data, {
      headers: {
        'X-Header-PlatformId': '2',
      },
    })
    .json()
}

// 创建报告任务
export const reportTask = (data) => {
  return http()
    .post(`${getApiVersion()}/dynamic_report/task`, data, {
      throwHttpErrors: false,
    })
    .json()
}

// 同步案件
export const synchroCase = (appId, tbId, migrateDateTimestamp) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/xiChengRubbishSort/tbs/${tbId}/migrateProData?migrateDateTimestamp=${migrateDateTimestamp}`,
      {},
      {
        throwHttpErrors: false,
      }
    )
    .json()
}

/**
 * @function downloadFile
 * @desc 下载文件接口
 * @param {Number} appId 项目ID
 * @param {String} url 媒体文件路径
 * @returns {Object} 返回文件
 */
export const downloadFile = (appId, url, token) => {
  return `${getApiVersion()}/apps/${appId}/policyMon/downFile?url=${url}&token=${token}`
}

/**
 * @function getDownloadUrl
 * @desc  指定文件名下载文件
 * @param {Number} appId 项目ID
 * @param {String} fileName 媒体文件名称
 * @param {String} fileLink 媒体文件路径
 * @returns {Object} 返回文件
 */
export const getDownloadUrl = (appId, fileName, fileLink, token) => {
  return `${getApiVersion()}/apps/${appId}/policyMon/downFileAsName?fileName=${fileName}&fileLink=${fileLink}&token=${token}`
}

export const downloadTemplateUrl = (appId, tbId, token) => {
  return `${getApiVersion()}/apps/${appId}/dataImport/fetchImportTemplateToResponse?tbId=${tbId}&needSystemData=false&token=${token}`
}

// 通过电子表格导入数据
export const importData = (
  appId,
  tbId,
  standardArea,
  firstColumnPicture,
  data
) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/dataImport/importDataViaXlsxWithPicture?tbId=${tbId}&standardArea=${standardArea}&firstColumnPicture=${firstColumnPicture}`,
      null,
      {
        body: data,
      }
    )
    .json()
}
// 上传我的政策
export const importZcData = (appId, tbId, importTbId, data) => {
  console.log(data)
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/dataImport/importFileToFIleTableAndExcelTable?fileTableId=${tbId}&importTableId=${importTbId}`,
      null,
      {
        body: data,
      }
    )
    .json()
}

//  上传点位
export const updateXlsxTbData = (appId, tbId, data, slugs) => {
  return http().post(
    `${getApiVersion()}/apps/${appId}/dataImport/updateViaXlsx?tbId=${tbId}&slugs=${slugs}`,
    null,
    {
      body: data,
    }
  )
}
